export default __webpack_public_path__ + "static/media/whiteYoutube.2bf47d07.svg";